import React, { Component } from 'react';
import get from 'lodash/get';
import { connect } from 'react-redux';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import moment from 'moment';
import ReactSelect from 'react-select';
import { Spinner, DateRange } from '../../../components/common';
import { SspApi } from '../../../api';
import { findPredicate, findComparator } from '../../../utils/helpers/filter_conversions';
import { ButtonExport } from '../../../components/common/buttons';

class FeedReport extends Component {

  state = { ssp_feed_id: '' };

  componentDidMount() {
    this.fetchResource();
    this.fetchFeeds();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.website.uuid !== this.props.website.uuid) {
      this.fetchResource();
      this.fetchFeeds();
    }
  }

  fetchFeeds(params = {}) {
    const { website, dispatch } = this.props;
    if (website.uuid) {
      const data = { ...params, ssp_website_id: website.uuid };
      dispatch(SspApi.actions.feeds.get(data));
    }
  }

  fetchResource(params = {}) {
    const { website, dispatch } = this.props;
    if (website.uuid) {
      const data = { ...params, ssp_website_id: website.uuid };
      dispatch(SspApi.actions.reports.get(data));
    }
  }

  handleOnFilterChange(e) {
    const filters = get(this.props, 'reports.meta.filters', {});
    Object.entries(e).forEach(([field, properties]) => {
      switch (properties.type) {
        case 'NumberFilter': {
          const { value: { comparator, number } } = properties;
          filters[field] = { value: number, predicate: findPredicate(comparator) };
          break;
        }
        case 'SelectFilter': {
          const { value } = properties;
          filters[field] = { value };
          break;
        }
        default:
          break;
      }
    });

    this.fetchResource({
      page: get(this.props, 'reports.meta.pagination.page', 1),
      per_page: get(this.props, 'reports.meta.pagination.page', 31),
      filters,
      sort: get(this.props, 'reports.meta.sort', {})
    });
  }

  handleOnSortChange(field, order) {
    const sort = { field, order };
    this.fetchResource({
      page: get(this.props, 'reports.meta.pagination.page', 1),
      per_page: get(this.props, 'reports.meta.pagination.page', 31),
      filters: get(this.props, 'reports.meta.filters', {}),
      sort
    });
  }

  handleOnPageChange(page, per_page) {
    this.fetchResource({
      page,
      per_page,
      filters: get(this.props, 'reports.meta.filters', {}),
      sort: get(this.props, 'reports.meta.sort', {})
    });
  }

  handleDateApply(d) {
    const filters = get(this.props, 'reports.meta.filters', {});

    filters.daterange = {
      start_date: { value: d.startDate.format() },
      end_date: { value: d.endDate.format() }
    };

    this.fetchResource({
      page: get(this.props, 'reports.meta.pagination.page', 1),
      per_page: get(this.props, 'reports.meta.pagination.page', 31),
      filters,
      sort: get(this.props, 'reports.meta.sort', {})
    });
  }

  handleFeedSelect(s) {
    this.setState({ ...this.state, ssp_feed_id: ((s || {}).value || '') }, () => {
      const filters = get(this.props, 'reports.meta.filters', {});
      filters.ssp_feed_id = { value: this.state.ssp_feed_id };

      this.fetchResource({
        page: get(this.props, 'reports.meta.pagination.page', 1),
        per_page: get(this.props, 'reports.meta.pagination.page', 31),
        filters,
        sort: get(this.props, 'reports.meta.sort', {})
      });
    })
  }

  generateFilter(dataField) {
    const { value, predicate } = get(this.props, `reports.meta.filters.${dataField}`, {});
    let filter = {};
    switch (dataField) {
      case 'earned':
      case 'conversions':
      case 'acpa':
      case 'acpc':
      case 'clicks':
      case 'impressions': {
        filter.type = 'NumberFilter';
        filter.numberComparators = ['=', '>', '<'];
        filter.defaultValue = {};
        if (value && predicate) {
          filter.defaultValue = {
            number: parseInt(value, 10),
            comparator: findComparator(predicate)
          };
        }
        break;
      }
      case 'report_type': {
        filter.type = 'SelectFilter';
        filter.options = {
          cpc: 'cpc',
          cpa: 'cpa'
        };
        filter.defaultValue = 'cpc';
        break;
      }
      default:
        filter = {};
    }
    return filter;
  }

  render() {
    const { reports, isLoading, website, feeds } = this.props;
    const { data, meta } = reports || {};
    const feedData = ((feeds || {}).data || []);
    const { pagination, sort } = meta || {};

    const feedOptions = feedData.map((f) => {
      return { label: f.name, value: f.id }
    })

    const sd = get(meta,
      'filters.daterange.start_date.value', moment().startOf('month').toISOString());
    const ed = get(meta,
      'filters.daterange.end_date.value', moment().endOf('month').toISOString());

    const daterange = { start_date: sd, end_date: ed };

    const totalCount = get(pagination, 'total_count', 100);
    const perPageList = [{ text: '31', value: 31 }, { text: '62', value: 62 }, { text: 'All', value: totalCount }];

    const ExportCSVButton = (onClick) => {
      return (
        <ButtonExport
          onClick={onClick}
          className='m-b-sm'
          btnLabel='Export to CSV'
        />
      );
    };

    const options = {
      exportCSVBtn: ExportCSVButton,
      onFilterChange: this.handleOnFilterChange.bind(this),
      onSortChange: this.handleOnSortChange.bind(this),
      sortName: get(sort, 'field', 'day'),
      sortOrder: get(sort, 'order', 'asc'),
      defaultSortName: get(sort, 'field', 'day'),
      defaultSortOrder: get(sort, 'order', 'asc'),
      sizePerPage: get(pagination, 'per_page', 31),
      onPageChange: this.handleOnPageChange.bind(this),
      sizePerPageList: perPageList,
      pageStartIndex: 1,
      page: get(pagination, 'current_page', 1)
    };

    const fetchInfo = {
      dataTotalSize: totalCount || 0
    };

    const ranges = {
      'Last 7 Days': [moment().subtract(6, 'days'), moment()],
      'Last 30 Days': [moment().subtract(29, 'days'), moment()],
      'This Month': [moment().startOf('month'), moment().endOf('month')],
      'Last Month': [
        moment().subtract(1, 'month').startOf('month'),
        moment().subtract(1, 'month').endOf('month')
      ]
    };

    const colSum = (tableData, field, dataType) => {
      let label = 0;
      for (let i = 0, tableDataLen = tableData.length; i < tableDataLen; i++) {
        label += parseFloat(tableData[i][field]);
      }
      return (
        <strong>{dataType === 'integer' ? parseInt(label) : label.toFixed(2)}</strong>
      );
    };

    const colAvg = (tableData, field) => {
      let earned = 0;
      for (let i = 0, tableDataLen = tableData.length; i < tableDataLen; i++) {
        earned += parseFloat(tableData[i].earned);
      }

      let typeVal = 0;
      for (let i = 0, tableDataLen = tableData.length; i < tableDataLen; i++) {
        typeVal += parseFloat(tableData[i][field]);
      }

      const label = typeVal === 0 ? 0 : (earned / typeVal);

      return (
        <strong>{label.toFixed(2)}</strong>
      );
    };

    const footerData = [
      [
        {
          label: 'Total',
          columnIndex: 0
        },
        {
          columnIndex: 1,
          align: 'left',
          formatter: (e) => colSum(e, 'earned')
        },
        {
          columnIndex: 2,
          align: 'left',
          formatter: (e) => colAvg(e, 'clicks')
        },
        {
          columnIndex: 3,
          align: 'left',
          formatter: (e) => colSum(e, 'clicks', 'integer')
        },
        {
          columnIndex: 4,
          align: 'left',
          formatter: (e) => colSum(e, 'impressions', 'integer')
        }
      ]
    ];

    return (
      <div className='ibox'>
        <div className='ibox-title'>
          <h5>Feed Report</h5>
          <div className='ibox-tools'>
            <DateRange
              key={`daterange-${website.uuid}`}
              defaultChosenLabel='This Month'
              opens='left'
              startDate={moment(daterange.start_date)}
              endDate={moment(daterange.end_date)}
              ranges={ranges}
              onApply={this.handleDateApply.bind(this)}
            />
            <ReactSelect
              instanceId={`instanceId-ssp_feed_id`}
              name="ssp_feed_id"
              className='requestGroupBy'
              options={feedOptions}
              placeholder="Select a feed"
              onChange={this.handleFeedSelect.bind(this)}
              value={this.state.ssp_feed_id}
              valueKey="value"
              labelKey="label"
            />
          </div>
        </div>
        <div className={`ibox-content${isLoading ? ' sk-loading' : ''}`}>
          <Spinner />
          <BootstrapTable
            exportCSV
            csvFileName='website-earnings-report.csv'
            striped
            ref='ReportsTable'
            data={data || []}
            footerData={footerData}
            footer
            remote
            pagination
            fetchInfo={fetchInfo}
            options={options}
          >
            <TableHeaderColumn
              width='145'
              dataSort
              csvHeader='Date'
              dataField='day'
              dataFormat={(c) => moment(c).local().format('MMMM Do[,] YYYY')}
            >
              Date
                </TableHeaderColumn>

            <TableHeaderColumn
              width='145'
              dataSort
              csvHeader='$ Earned'
              dataField='earned'
              filter={this.generateFilter('earned')}
              dataFormat={(c) => c}
            >
              $ Earned
                </TableHeaderColumn>

            <TableHeaderColumn
              width='145'
              dataSort
              csvHeader='Average CPC'
              dataField='acpc'
              filter={this.generateFilter('acpc')}
              dataFormat={(c) => c}
            >
              Average CPC
                </TableHeaderColumn>

            <TableHeaderColumn
              width='145'
              dataSort
              csvHeader='Clicks'
              dataField='clicks'
              filter={this.generateFilter('clicks')}
              dataFormat={(c) => c}
            >
              Clicks
                </TableHeaderColumn>

            <TableHeaderColumn
              width='200'
              dataSort
              csvHeader='Impressions'
              dataField='impressions'
              filter={this.generateFilter('impressions')}
              dataFormat={(c) => c}
            >
              Impressions
                </TableHeaderColumn>

            <TableHeaderColumn
              isKey
              hidden
              width='0'
              dataField='id'
            />

          </BootstrapTable>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { ssp } = state;
  return { reports: ssp.reports.data, feeds: ssp.feeds.data, isLoading: ssp.reports.loading };
};

export default connect(mapStateToProps)(FeedReport);